export function formatAbbr(address: string, length = 5) {
  const start = address.substring(0, length)
  const end = address.substring(address.length - length)
  return `${start}...${end}`
}
